import React, { useState, useEffect } from "react";
import { DataProfileComp, EditProfileComp } from "../../components";
import Modal from "react-bootstrap/Modal";
import axios from "../../library/axios";
import { setHrefWithSlugHook } from "../../../src/config/routes/guards/slug";
import { clearHospitalToken } from "../../helpers/hospitalAuth";

const ProfilePage = () => {
  const [profile, setprofile] = useState({});
  const [contactPerson, setcontactPerson] = useState({});
  const [lgShowUpdate, setLgShowUpdate] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchOneProfile = async (id) => {
    const { data } = await axios({
      url: `/profile/profil-param/${id}`,
      method: "GET",
    });
    setprofile(data);
    setcontactPerson(data.contact_people?.[0] || {});
  };

  useEffect(() => {
    let cancelled = false;

    const loadProfile = async () => {
      setLoading(true);
      try {
        await axios({ url: "/users/detailUser", method: "GET" });

        const { data: profiles } = await axios({
          url: "/profile/list",
          method: "GET",
        });

        if (cancelled) return;

        const profileId = profiles?.[0]?.id;
        if (!profileId) {
          setprofile({});
          setcontactPerson({});
          return;
        }

        await fetchOneProfile(profileId);
      } catch (err) {
        if (cancelled) return;
        if (err?.response?.status === 401) {
          clearHospitalToken();
          setHrefWithSlugHook("/login");
          return;
        }
        console.log(err?.response?.data?.message || err.message);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadProfile();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleEdit = () => {
    setLgShowUpdate(true);
  };

  const refreshProfile = async () => {
    try {
      const { data: profiles } = await axios({
        url: "/profile/list",
        method: "GET",
      });
      const profileId = profiles?.[0]?.id;
      if (profileId) {
        await fetchOneProfile(profileId);
      }
    } catch (err) {
      console.log(err?.response?.data?.message || err.message);
    }
  };

  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div className="toolbar" id="kt_toolbar">
          <div id="kt_toolbar_container" className="container-fluid d-flex flex-stack">
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Halaman Profil
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                <small className="text-muted fs-7 fw-bold my-1 ms-1">#SPEAK_VERSI_RS</small>
              </h1>
            </div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="container-xxl">
            {loading ? (
              <div className="text-muted py-5">Memuat profil...</div>
            ) : (
              <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                  <DataProfileComp
                    profile={profile}
                    contactPerson={contactPerson}
                    handleEdit={() => handleEdit()}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        show={lgShowUpdate}
        onHide={() => setLgShowUpdate(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditProfileComp
            profile={profile}
            fetch={refreshProfile}
            close={() => setLgShowUpdate(false)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProfilePage;
